import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { api } from "../lib/api";
import { Reveal } from "../lib/ui";

const day = (v) => {
  const d = new Date(v);
  return Number.isNaN(d.getTime()) ? "" : d.toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
};

/** Proof of movement, dated: the newest things that actually happened, not another model. */
export const WhatHasMoved = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    api.get("/live-feed?limit=5").then((r) => setItems(r.data.items || [])).catch(() => setItems([]));
  }, []);

  if (!items.length) return null;

  return (
    <section className="border-t border-zinc-900 bg-[#070707] py-14 md:py-20" data-testid="home-what-has-moved">
      <div className="mx-auto max-w-[1200px] px-5 md:px-10">
        <Reveal>
          <p className="overline text-ochre">What has actually moved</p>
          <h2 className="display-3 mt-4 max-w-3xl">Dated, Not Promised</h2>
        </Reveal>
        <ul className="mt-8 divide-y divide-zinc-900 border-y border-zinc-900">
          {items.map((it, i) => (
            <li key={`${it.title}-${i}`} data-testid={`has-moved-${i}`}>
              <Link to={it.to || "/updates"}
                className="group flex flex-col gap-1 py-4 transition-colors hover:bg-white/[0.03] sm:flex-row sm:items-center sm:gap-6">
                <span className="mono w-32 shrink-0 text-[0.55rem] uppercase tracking-[0.16em] text-zinc-500">
                  {day(it.at)}
                </span>
                <span className="mono w-24 shrink-0 text-[0.55rem] uppercase tracking-[0.16em] text-ochre">
                  {it.kind}
                </span>
                <span className="flex-1 text-sm text-zinc-300 group-hover:text-white">{it.title}</span>
                <ArrowUpRight size={14} className="hidden shrink-0 text-zinc-600 group-hover:text-ochre sm:block" />
              </Link>
            </li>
          ))}
        </ul>
        <Link to="/updates" className="btn-ghost mt-8 inline-flex items-center gap-2" data-testid="has-moved-all">
          The full file <ArrowUpRight size={14} />
        </Link>
      </div>
    </section>
  );
};
